import { TimeRange } from '../../models/time-range';

export enum TimeRangeType {
  MOVING_WINDOW = 'moving_window',
  MONITORING_SESSION = 'monitoring_session',
  FIXED_RANGE = 'fixed_range'
}

export enum TimeRangeLabel {
  CUSTOM = 'Custom date',
  LAST_1H = 'Last hour',
  LAST_12H = 'Last 12 hours',
  LAST_DAY = 'Last day',
  LAST_WEEK = 'Last week',
  MINUS_24H = '- 24 hours',
  PLUS_24H = '+ 24 hours',
  REFRESH_TIME = '(refresh every 5 min)'
}

export enum TimeRangeKey {
  LAST_1H = 'LAST_1H',
  LAST_1H_CACHED = 'LAST_1H_CACHED',
  LAST_12H = 'LAST_12H',
  LAST_1DAY = 'LAST_1DAY',
  LAST_1WEEK = 'LAST_1WEEK',
  CUSTOM = 'CUSTOM',
  MINUS_24H = 'MINUS_24H',
  PLUS_24H = 'PLUS_24H',
  LAST_30DAYS = 'LAST_30DAYS'
}

export interface TimeRangeGranularity {
  // duration (in milliseconds)
  minDuration?: number;
  maxDuration?: number;
  // the time duration to truncate (milliseconds)
  truncateTime: number;
}

export enum TimeZone {
  UTC = 'UTC'
}

export enum TimeInMs {
  Month = 2592000000,
  Day = 86400000,
  TwelveHours = 43200000,
  Hour = 3600000,
  HalfHour = 1800000,
  QuarterHour = 900000,
  Minute = 60000,
  Second = 1000
}

export interface TimestampRange {
  fromTime: number;
  toTime: number;
}

export interface TimePickerOption {
  timeRange: TimeRange;
  label: string;
  rangeFormatter?(timeRange: TimeRange): string;
}

export enum TimePickerNames {
  LAST_60_MINS = 'Last 60 minutes',
  LAST_60_MINS_FAST = 'Last 60 minutes (5min offset - fast)',
  LAST_60_MINS_SLOW = 'Last 60 minutes (5min offset - slower)',
  LAST_24_HOURS = 'Last 24 hours'
}
